import Control from "can-control";

import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import FormRecall from "@/js/controllers/form/recall.js";



/**
 * Контроллер кнокпи Задать вопрос
 **/
const ButtonMakeQuestion = Control.extend(
    {
        form: null
    },
    {
        init() {

            const _this = this;
            
            document.querySelectorAll('button').forEach((button) => {
                button.addEventListener('click', () => {
                    _this.action(button);
                })
            });

        },
        action(button) {

            let html = null;
            let wrapForm = null;

            if (button.getAttribute('data-type') === 'form-phone') {
                wrapForm = document.getElementById('form-phone');
                new FormRecall(wrapForm.querySelector('form'));
                html = wrapForm.innerHTML;
            }

            if (button.getAttribute('data-type') === 'form-calculate') {
                wrapForm = document.getElementById('form-calculate');
                new FormRecall(wrapForm.querySelector('form'));
                html = wrapForm.innerHTML;
            }

            if (button.getAttribute('data-type') === 'make-question') {
                wrapForm = document.getElementById('FormFaq');
                html = wrapForm.innerHTML;
            }

            if (html) {
                
                new Fancybox([
                    {
                        src: html,
                        type: "html",
                    },
                ], {
                    mainClass: "popup popup--black_"+button.getAttribute('data-type'),
                    on: {
                        reveal: (fancybox) => {
                            const elementForm = fancybox.container.querySelector('form');
                            return new FormRecall(elementForm)
                        },
                        close: (fancybox) => {

                        },
                    },
                });
            }
        },
    }
);

export default ButtonMakeQuestion;
